// @module C3.ShoppingExtensions.MeetTeam
define('C3.ShoppingExtensions.MeetTeam.View'
,	[
	'c3_shoppingextensions_meetteam.tpl'
	
	,	'C3.ShoppingExtensions.MeetTeam.Cell.View'
	,   'Backbone.CollectionView'
	,   'facets_items_collection_view_cell.tpl'
	,   'facets_items_collection_view_row.tpl'
	,   'facets_items_collection.tpl'
	,	'Backbone'
	,   'GlobalViews.Breadcrumb.View'
	,   'Utils'
    ]
, function (
	c3_shoppingextensions_meetteam_tpl
	
	,	C3ShoppingExtensionsMeetTeamCellView
	,   BackboneCollectionView
	,   facets_items_collection_view_cell_tpl
	,   facets_items_collection_view_row_tpl
	,   facets_items_collection_tpl
	,	Backbone
	,   GlobalViewsBreadcrumbView
	,   Utils
)
{
    'use strict';

	// @class C3.ShoppingExtensions.MeetTeam.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_meetteam_tpl

	,	initialize: function (options) {
			this.options = options;
			this.application = options.application;
			this.configuration = this.application.Configuration;
			this.layout = options.layout
			
			var meetOurTeam = this.configuration.MeetOurTeam
			this.meetOurTeamConfig = meetOurTeam.config;
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {
			'MeetOurTeamList': function() {
					var viewsPerRow = 3;
					
					if(Utils.isPhoneDevice())
						viewsPerRow = 2

				   return new BackboneCollectionView({
	                collection: this.meetOurTeamConfig,
	                viewsPerRow: viewsPerRow,
	                childViewOptions : {
	                	application : this.application,
	                	layout : this.layout
	                },
	                childView: C3ShoppingExtensionsMeetTeamCellView,
	                cellTemplate: facets_items_collection_view_cell_tpl,
	                rowTemplate: facets_items_collection_view_row_tpl,
	                template: facets_items_collection_tpl
	            });
            },
            'Global.Breadcrumb': function() {
				var meetOurTeamBreadcrumbs = [];

				 meetOurTeamBreadcrumbs[0] = {
		                href : '/',
		                'data-hashtag' : '#',
		                'data-touchpoint': "home",
		                hasDataHashtag: true,
		                hasDataTouchpoint: true,
		                text: "Home"
		          }

	           	meetOurTeamBreadcrumbs[1] = {
                     href : '/',
                     text: 'Meet Our Team'
                }

		          //console.log(this.currentPage)

	        	return new GlobalViewsBreadcrumbView({
	        			 pages: meetOurTeamBreadcrumbs 
	        		});
        	}
		}

		//@method getContext @return C3.ShoppingExtensions.MeetTeam.View.Context
	,	getContext: function getContext()
		{
			console.log(this.meetOurTeamConfig)
			var mywindowWidth = jQuery(window).width();
			return {
				isPhoneDevice: Utils.isPhoneDevice(),
				largerDeviceBreadcrumbs : mywindowWidth >= 1440 ? true : false,
			};
		}
	});
});
